import Vue from 'vue'

export default ({ app, context }, inject) => {
    inject('bus', new Vue());
    const alert = {
        error: function(message){
            app.$bus.$emit('snackbar:error', message);
        },
        success: function(message){
            app.$bus.$emit('snackbar:success', message);
        },
        info: function(message){
            app.$bus.$emit('snackbar:info', message);
        },
    }
    inject('alert', alert)
}
